// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutDeliveryMethodStyles } from "@sc/Overrides/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutDeliveryMethodStyles.servicesGridItem = { width: [12, 12, 12, 6, 6] };
onePageCheckoutDeliveryMethodStyles.deliveryDateGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        & > div {
            display: flex;
        }
    `,
};
onePageCheckoutDeliveryMethodStyles.titleText = {
    variant: "h3",
    forwardAs: "h2",
    css: css`
        margin-bottom: -8px;
    `,
};
onePageCheckoutDeliveryMethodStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 135px;
        row-gap: 24px;
    `,
};
onePageCheckoutDeliveryMethodStyles.titleGridItem = {
    css: css`
        width: 100%;
    `,
};
onePageCheckoutDeliveryMethodStyles.noCarriersFoundGridItem = {
    css: css`
        width: 100%;
    `,
};
onePageCheckoutDeliveryMethodStyles.servicesGridItem = {
    css: css`
        width: calc((100% - 135px) / 2);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
onePageCheckoutDeliveryMethodStyles.deliveryDateGridItem = {
    css: css`
        width: calc((100% - 135px) / 2);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
onePageCheckoutDeliveryMethodStyles.pickUpDateGridItem = {
    css: css`
        width: calc((100% - 135px) / 2);
        ${xScreen("lte", "md")} {
            width: 100%;
            max-width: 100%;
        }
    `,
};
onePageCheckoutDeliveryMethodStyles.pickUpDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};
onePageCheckoutDeliveryMethodStyles.deliveryDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};
onePageCheckoutDeliveryMethodStyles.shipWhenCompleteCheckbox = {
    css: css`
        margin-top: 16px;
    `,
};
